import React, { Component } from 'react'
import { Link } from 'react-router'

// import styles
import './nomatch.scss'

class NoMatch extends Component {

  render () {
    return (
      <div className='nomatch__screen'>
        <div className='nomatch__wrapper'>
          <span>404</span>
          <h1>Page not found</h1>
          <Link to='/'>Home</Link>
        </div>
      </div>
    )
  }

}

export default NoMatch



// WEBPACK FOOTER //
// ./src/app/pages/NoMatch/index.js